import React from 'react';
const ModalGreenButton = ({onClick, text}) => {
    return (
        <button onClick={()=>onClick()} className='bg-green-400 p-2 mx-auto w-full rounded-lg text-gray-700'>{text.toUpperCase()}</button>
    );
}
 
export default ModalGreenButton;